import { ApplicationService } from '@/app/application.service';
import { ApplicationReloader } from '@/app/application-reloader';
import { Injectable } from '@angular/core';
import { PREFERRED_LANGUAGE_STORAGE_KEY } from '@/app/core/pages/public-account/language-selector/language-selector.component';

const appVersionKey = 'appVersion';

/**
 * Starttaal die installaties van vóór 0.9.1 impliciet hadden (Transloco-standaard
 * was NL). Sinds 0.9.1 is de standaard voor níeuwe installaties EN
 * (multi-language.module.ts); wie al in de app zat, blijft in het Nederlands
 * tenzij die zelf wisselt.
 */
const LEGACY_DEFAULT_LANGUAGE = 'nl';

@Injectable({
  providedIn: 'root'
})
export class AppVersionInitializer {
  constructor(
    private readonly applicationService: ApplicationService,
    private readonly applicationReloader: ApplicationReloader
  ) {}

  init(): AppVersionInitializationConsequence {
    const currentSavedVersion = localStorage.getItem(appVersionKey);
    const actualVersion = this.applicationService.version;

    if (currentSavedVersion !== actualVersion) {
      // BELANGRIJK — de taalkeuze overleeft de clear: zonder dit viel elke
      // gebruiker na élke update terug op de Transloco-standaard. Een bestaande
      // installatie (er stond al een versie) zonder expliciete keuze draaide in
      // NL en blijft dat; enkel een verse installatie krijgt de nieuwe EN-standaard.
      const preferredLanguage =
        localStorage.getItem(PREFERRED_LANGUAGE_STORAGE_KEY) ??
        (currentSavedVersion !== null ? LEGACY_DEFAULT_LANGUAGE : null);
      localStorage.clear();
      localStorage.setItem(appVersionKey, actualVersion);
      if (preferredLanguage !== null) {
        localStorage.setItem(PREFERRED_LANGUAGE_STORAGE_KEY, preferredLanguage);
      }
      this.applicationReloader.reloadToCurrentUrl();
      return 'reload';
    }

    return 'nothing';
  }
}

export type AppVersionInitializationConsequence = 'nothing' | 'reload';
